import {CompetitorBrandsModalConfig} from "../types/competitor-brands-modal.types";
import {
  CompetitorArticlesModalComponent
} from "../components/modals/competitor-articles-modal/competitor-articles-modal.component";

const competitorBrandsFieldConfig = {
  competitorArticles: { component: CompetitorArticlesModalComponent, width: '450px' }
} as const;

export const competitorBrandsModalConfig: Record<string, CompetitorBrandsModalConfig> =
  Object.fromEntries(
    Object.entries(competitorBrandsFieldConfig).map(([fieldName, config]) => [
      fieldName,
      {
        ...config,
        fieldName
      }
    ])
  );
